import { doGetChanges } from 'components/providers/GetChangesProvider'
import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'

export function triggerInheritanceSync(deviceChangeId?: string | null) {
  void doGetChanges(
    deviceChangeId,
    undefined,
    LocalStorage.get(LocalStorageKey.LAST_UPDATE),
    true
  )
}